import React from 'react'
import {Icon} from '@chakra-ui/react'

const AddIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="add-icon" fill="none" {...props} aria-hidden="true">
            <path
                d="M10.667 19.9999H29.3337"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 10.6666V29.3332"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default AddIcon
